import { jsx as _jsx } from "react/jsx-runtime";
import classnames from 'classnames';
export { ListGroupItem } from './ListGroupItem';
export const ListGroup = (props)=>{
    const { className, componentClass: Component = 'ul', flush, horizontal, numbered, children } = props;
    let horizontalClass;
    if (horizontal === true) horizontalClass = 'list-group-horizontal';
    if (horizontal && horizontal !== true) horizontalClass = `list-group-horizontal-${horizontal}`;
    const bsClass = classnames('list-group', {
        'list-group-flush': flush
    }, {
        'list-group-numbered': !!numbered
    }, horizontalClass, className);
    return /*#__PURE__*/ _jsx(Component, {
        className: bsClass,
        children: children
    });
};
